import { IEnvironment } from "../../interfaces";
import { DICTIONARY_KEY } from "./Compare.consts";

export const filterEnvData = (
  envData: any,
  filterKey: string,
  compareKey: string
) => {
  if (compareKey === DICTIONARY_KEY) {
    return envData.find((dic: { id: string }) => dic.id === filterKey);
  }

  return envData[filterKey];
};

export const getFilterItems = (
  envData: Record<string, { id: string }>,
  compareKey: string
) => {
  if (compareKey === DICTIONARY_KEY) {
    return Object.keys(envData).map((filterKey) => ({
      value: envData[filterKey].id,
      label: envData[filterKey].id,
    }));
  }

  return Object.keys(envData).map((filterKey) => ({
    value: filterKey,
    label: filterKey,
  }));
};

export const getEnvs = (envs: IEnvironment[]) => {
  const mappedEnvs: Record<string, string> = {};

  envs?.forEach((env) => {
    mappedEnvs[`${env?.name} UAT`] = env?.uat;
  });

  envs?.forEach((env) => {
    mappedEnvs[`${env?.name} PROD`] = env?.prod;
  });

  mappedEnvs["dev"] = "https://dev.hcp-locator.com/";
  mappedEnvs["TST"] = "https://tst.hcp-locator.com/";

  return mappedEnvs;
};
